"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
var React = require("react");
var reactstrap_1 = require("reactstrap");
var fa_1 = require("react-icons/fa");
var StyleComponents_1 = require("./base/StyleComponents");
var react_router_dom_1 = require("react-router-dom");
var Footer = /** @class */ (function (_super) {
    __extends(Footer, _super);
    function Footer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Footer.prototype.render = function () {
        return (React.createElement("footer", { style: {
                borderTop: '1px solid',
                backgroundImage: 'linear-gradient(10deg, black, transparent 35%, transparent 65%, black)'
            }, className: "text-center text-lg-start" },
            React.createElement("div", { style: {
                    width: '100%',
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'space-around',
                    rowGap: '2em',
                    padding: '1em 1em 1em 1em',
                    backgroundImage: 'linear-gradient(45deg, white -20%, rgb(193, 135, 6) 50%, white 120%)',
                    borderBottom: '1px solid',
                    boxShadow: '0 -0.2em 0.2em rgb(193 135 6)'
                } },
                React.createElement("img", { src: "image/logo/winnice_dolnoslaskie.png", style: { height: 100 } }),
                React.createElement("img", { src: "image/logo/dspiw_logo.png", style: { maxHeight: 100, maxWidth: '80%' } }),
                React.createElement("img", { src: "image/logo/kulinarnedziedzictwo.jpg", style: { height: 100 } }),
                React.createElement("img", { src: "image/logo/medal.png", style: { height: 100 } })),
            React.createElement("section", { className: "" },
                React.createElement("div", { className: "container text-center text-md-start mt-5", style: { color: 'floralWhite' } },
                    React.createElement("div", { className: "row mt-3" },
                        React.createElement("div", { className: "col-md-3 col-lg-4 col-xl-3 mx-auto mb-4" },
                            React.createElement("img", { style: { maxHeight: '200px' }, src: 'image/logo_cieniowane_pelne_male.png' })),
                        React.createElement("div", { className: "col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4" },
                            React.createElement("h6", { className: "text-uppercase fw-bold mb-4", style: { color: StyleComponents_1.goldColor, letterSpacing: '.2em' } }, "DANE KONTAKTOWE"),
                            React.createElement("hr", null),
                            React.createElement("p", null,
                                React.createElement(fa_1.FaEnvelope, null),
                                " ryszard.gut@wp.pl"),
                            React.createElement("p", null,
                                React.createElement(fa_1.FaEnvelope, null),
                                " kontakt@winnicaswidnicka.eu"),
                            React.createElement("p", null,
                                React.createElement(fa_1.FaPhoneAlt, null),
                                " 662 043 709"),
                            React.createElement("p", null,
                                React.createElement(fa_1.FaPhoneAlt, null),
                                " 604 901 954")),
                        React.createElement("div", { className: "col-md-2 col-lg-2 col-xl-2 mx-auto mb-4", style: { color: StyleComponents_1.goldColor, letterSpacing: '.2em' } },
                            React.createElement("h6", { className: "text-uppercase fw-bold mb-4" }, "OBSERWUJ NAS"),
                            React.createElement("hr", null),
                            React.createElement(reactstrap_1.Navbar, null,
                                React.createElement(reactstrap_1.Nav, { navbar: true, style: { fontSize: 40, display: 'flex', justifyContent: 'center' } },
                                    React.createElement("div", { style: { display: 'flex' } },
                                        React.createElement(reactstrap_1.NavLink, { tag: react_router_dom_1.Link, href: "https://www.facebook.com/WinnicaSwidnicka/" },
                                            React.createElement(fa_1.FaFacebookSquare, null)),
                                        React.createElement(reactstrap_1.NavLink, { href: "https://www.instagram.com/winnica.swidnicka/" },
                                            React.createElement(fa_1.FaInstagramSquare, null))),
                                    React.createElement("div", { style: { display: 'flex' } },
                                        React.createElement(reactstrap_1.Col, null,
                                            React.createElement(reactstrap_1.NavLink, { href: "" },
                                                React.createElement(fa_1.FaYoutube, null))),
                                        React.createElement(reactstrap_1.Col, null,
                                            React.createElement(reactstrap_1.NavLink, { href: "" },
                                                React.createElement(fa_1.FaTripadvisor, null))))))),
                        React.createElement("div", { className: "col-md-3 col-lg-2 col-xl-2 mx-auto mb-4" },
                            React.createElement("h6", { className: "text-uppercase fw-bold mb-4", style: { color: StyleComponents_1.goldColor, letterSpacing: '.2em' } }, "ADRES"),
                            React.createElement("hr", null),
                            React.createElement("p", null,
                                React.createElement(fa_1.FaHome, null),
                                " WINNICA",
                                React.createElement("br", null),
                                "Makowice",
                                React.createElement("br", null),
                                "58-100 \u015Awidnica"),
                            React.createElement("p", null,
                                React.createElement(fa_1.FaHome, null),
                                " WINIARNIA/SKLEP",
                                React.createElement("br", null),
                                "ul. Kraszowicka 23",
                                React.createElement("br", null),
                                "58-100 \u015Awidnica",
                                React.createElement("br", null)))))),
            React.createElement("div", { className: "text-center p-4", style: { backgroundColor: 'rgba(0, 0, 0, 0.00)' } }, "\u00A9 2021 Prawa zastrze\u017Cone: Oskar Gut")));
    };
    return Footer;
}(React.Component));
exports.Footer = Footer;
//# sourceMappingURL=Footer.js.map